export default function StatisticsCard({ title, value, imgUrl, className }) {
    return (

        <div className={className}>
            <div className="count-card p-3 card">
                <div className="d-flex align-items-center mb-1 lh-1 d-block ">
                    {imgUrl && imgUrl != "" && (
                        <img src={imgUrl} height="25" className="me-2" />
                    )}
                    <strong style={{ whiteSpace: "break-spaces", overflowWrap: "anywhere" }}>{title}</strong>
                </div>
                <div className="mt-3"><h3>{value}</h3></div></div>
        </div>
    )
}
